import { useRecoilValue } from "recoil";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import MatchMakingPartyTab, {
  matchMakingPartyTabState,
} from "../../components/pages/Party/MatchMakingPartyInfo/MatchMakingPartyTab";
import MatchMakingParty from "../../components/pages/Party/MatchMakingPartyInfo/PartyInfo";
import MatchMakingEmail from "../../components/pages/Party/MatchMakingPartyInfo/EmailInfo";

export default function MatchMakingPartyInfo() {
  const tab = useRecoilValue(matchMakingPartyTabState);

  return (
    <>
      <PageTitle title="매치메이킹 파티" />

      <MatchMakingPartyTab />

      {tab === 0 ? <MatchMakingParty /> : <MatchMakingEmail />}
    </>
  );
}
